export const event = {
    //******** common
    /**
     * 通知主应用，子应用全屏状态
     * data: {
     *     fullScreen: true/false
     * }
     */
    COMMON_FULL_SCREEN: '/common/full_screen',

    //******** pptist
    /**
     * 通知pptist应用载入ppt
     * data:
     *  {
     *      url: "https://www.example.com/example.ppt",
     *      type: "preview"
     *  }
     *
     *  type: 'preview'|'demonstrate'|'edit-check'
     */
    PPTIST_LOAD_PPT: '/pptist/load_ppt',

    /**
     * ppt是否被修改
     * data: {}
     * res: {
     *     isModified: true
     * }
     */
    PPTIST_IS_MODIFIED: '/pptist/is_modified',

    //******** resource
    /**
     * webppt将新建的ppt上传完成后，将从接口拿到的资源地址通过本事件传递给资源中心，资源中心会完成后续的数据绑定
     * 完成数据绑定后资源中心将执行回调方法通知调用情况
     * data:
     *  {
     *      url: "www.baidu.com"    // ppt的url
     *      content: 'xxxxx'
     *      type: 0,                // 0为创建，1为编辑
     *      resource_type: 0,       // 0为ppt， 1为知识点
     *  }
     *
     */
    RESOURCE_UPDATE_RESOURCE: '/resource/update_resource',

    //*******  common
    /**
     * 通知主应用启动子应用
     * data : {
     *     app: 'pptist', //启动的微应用的名字
     *     entry: 'www.baidu.com', // 子应用对应的服务地址
     *     el: div#pptistInResource.pptistInResource // dom 节点
     *     args: {a: xx, b: xx} // 启动参数， 在子应用mounted的props参数的args属性里可以取到
     * }
     *
     */
    COMMON_LOAD_MICRO_APP: '/common/load_micro_app',

    //******   common
    /**
     *
     *  通知主应用移除某个子应用
     * 注意，只要是自己手动启动的子应用，在页面离开、主动删除div的时候，都需要通知主应用去进行卸载，否则会影响后续的打开
     * data: {
     *   app: 'xxx', // 需要移除的应用的名称，与启动时填写的app字段一致
     * }
     *
     *
    */
    COMMON_UNLOAD_MICRO_APP: '/common/unload_micro_app',

    //********  resource
    /**
     * 通知资源中心打开歌曲选择弹窗，完成后会调用后续的回调方法，将数据保存到回调参数的data中
     * data: {
     *    sid: 1,
     *    type: 'sheet',
     *    source: 'official'
     * }
     *
     * sid: 选择的歌曲的id
     * type: 'sheet'| 'enjoy' // sheet 为谱例歌曲，enjoy为欣赏歌曲
     *source: 'official'| 'teacher'
     */
    RESOURCE_OPEN_SONG_MODAL: '/resource/open_song_modal',

    //******* common
    /**
     * 通知主应用调用Message弹窗进行消息通知
     * data: {
     *     type: 'info',
     *     message: '需要进行消息通知的数据，是一个字符串'
     * }
     * 
     * type: 'info'| 'success' | 'error' | 'warning' 四个不同级别的警告
     * 
     */
    COMMON_NOTIFY_MESSAGE: '/common/notify_message',

    // ****** resource
    /**
     * 通知资源中心更新权限信息数据
     * 
     * data: {
     *    permissions: []
     * }
     * 
     * permissions里是最新的权限数据，由父应用提供，如果是SYSTEMADMIN，则为默认全权限
     * 
     */
    RESOURCE_UPDATE_PERMISSION: '/resource/update_permission',

    /**
     * 通知父应用这边加载一个全局加载框
     * 
     * data: {
     *   loading: true,
     *   timeout: 3000,
     * }
     * loading: 是否加载 ， true/false
     * timeout: 超时时间(s)，可选，默认值为3秒， 超过时间会自动关闭loading加载层
     * 
     */
    COMMON_SHOW_LOADING: '/common/show_loading',

    /**
     * 通知资源中心打开知识点弹窗，选择后会执行回调，将数据传入回调方法的data中
     * data: {
     *   source: 'teacher',
     *   content: 'xxxxx'
     * }
     * 
     * source: 'official'| 'teacher',来源，官方知识点还是个人的知识点
     * content: 知识点的内容
     */
    RESOURCE_OPEN_KNOWLEDGE_POINTS_MODAL: '/resource/open_knowledge_points_modal',

    /**
     * 通知ppt应用加载知识点，传入参数有： 
     * data: {
     *   content: 'xxxx',
     *   screening: false,
     *   screeningType:'edit-check'
     * }
     * 
     * content: 知识点加密字符串
     * screening： fasle| true
     * screeningType: 
     */
    PPTIST_LOAD_KNOWLEDGE_POINT: '/pptist/load_knowledge_point',

    /**
     * 修改菜单是否隐藏的状态
     * data: {
     *   collpased: false,
     * }
     * 
     * collpased: true| false
     * true: 隐藏
     * false： 展开
     */
    COMMON_CHANGE_COLLPASED: '/common/change_collpased',
}
